import { Box, Button, Flex, Heading } from 'ui'
import { AddCompanyMember } from 'components/AddCompanyMember'
import { Filter } from './Filter'

export const Header = () => {
  return (
    <Flex flexDirection="column" gap={2}>
      <Flex alignItems="center">
        <Heading level={3}>Pending Invites</Heading>
        <Box flex={1} />
        <AddCompanyMember trigger={<Button>+ Invite Team Member</Button>} />
      </Flex>
      <Filter />
    </Flex>
  )
}
